import { render } from "./QCDashboard.vue?vue&type=template&id=a4a49594&scoped=true"
import script from "./QCDashboard.vue?vue&type=script&lang=js"
export * from "./QCDashboard.vue?vue&type=script&lang=js"

import "./QCDashboard.vue?vue&type=style&index=0&id=a4a49594&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4a49594"]])

export default __exports__